import React, {useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import ajaxMark from '../../util/remote/ajaxMark';
import { useMarks } from '../../DataStore/MarksContext';

const AlertOrganiseClass = ({show, handleClose}) => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();
    const {getOrganisedMarks, paper, classRoom} = useMarks();


   
     const confirm=async()=>{
       setLoading(true);
        const server_response = await ajaxMark.organiseAllSubjectStudents(classRoom.class_id, paper.value);
         setLoading(false);
        if(server_response.status==="OK"){
            getOrganisedMarks();
            // handleClose();
             setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type="danger" message={server_response.message}/>)
        }

        handleClose();
    }

    return (
        <BsModal
            show={show}
            onClose={handleClose}
            title="Add Entire Class"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm Add
                    </button>
                    </>}
                </>
            }
        >


            <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Are you sure you want to add the entire class to the selected subject marksheet?</h5>

                <p className='text-secondary text-center' style={{fontSize: '14px'}}>This action will add all students in the class to the subject marksheet.</p>
            </div>
          

        </BsModal>
    );
};

export default AlertOrganiseClass;
